import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { FaEdit, FaWpforms } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import SplitPane from "react-split-pane";
import UpdateFormMetadata from "./UpdateFormMetadata";
import { CiSearch } from "react-icons/ci";
import Swal from "sweetalert2";
import DeletedFormMetadata from "./DeletedFormMetadata";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { useParams } from "react-router-dom";
import PullGlobalFormMetadata from "./PullGlobalFormMetadata";
import AddFormMetadataForm from "./AddFormMetadataForm";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import SpecialEventForAssignForm from "./FormMetadataProperties/SpecialEventForAssignForm";
import UseToggle from "../../../../Hooks/UseToggle";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import { NoDataFoundTable } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import FormMetadataProperties from "./FormMetadataProperties/FormMetadataProperties";
import FormMetadataActivities from "./FormMetadataProperties/FormMetadataActivities";
import FormMetadataReviewActivities from "./FormMetadataProperties/FormMetadataReviewActivities";
import FormMetadataUpdatedHistory from "./FormMetadataProperties/FormMetadataUpdatedHistory";
import EventListForAssignForm from "./FormMetadataProperties/EventListForAssignForm";
import EventListForInitiateForm from "./FormMetadataProperties/EventListForInitiateForm";
import TableProperties from "./FormMetadataProperties/TableProperties";
import DuplicateFormMetadataForm from "./DuplicateFormMetadataForm";
import EventQueryHistory from "./FormMetadataProperties/EventQueryHistory";
import Loader from "../../../../img/Document scan.gif"
import Pagination from "../../../Pagination";
const FormMetadataDataList = ({ onMouseDown, tableRef, handleAddNewTab }) => {
  const [searchData, setSearchData] = useState("");
  const [metadata, setMetadata] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [formMetadataList, setFormMetadataList] = useState([]);
  const [formMetadataListCount, setFormMetadataListCount] = useState(0);
  const [formDeletedMetadata, setFormDeletedMetadata] = useState([]);
  const [formDeletedMetadataCount, setFormDeletedMetadataCount] = useState(0);
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2, toggle3, setToggle3 } = UseToggle();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("properties");
  const [formId, setFormId] = useState("");
  const [activityLoader, setActivityLoader] = useState(false);
  const [formActivity, setFormActivity] = useState([]);
  const [formActivityCount, setFormActivityCount] = useState(0);
  const [reviewActivityLoader, setReviewActivityLoader] = useState(false);
  const [formReviewActivity, setFormReviewActivity] = useState([]);
  const [formReviewActivityCount, setFormReviewActivityCount] = useState(0);
  const [historyLoader, setHistoryLoader] = useState(false);
  const [formMetadataHistory, setFormMetadataHistory] = useState([]);
  const [tableColumns, setTableColumns] = useState({});
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isDuplicateFormOpen, setIsDuplicateFormOpen] = useState(false);
  const [updateButtonLoader, setUpdateButtonLoader] = useState(false)

  const formColumn = [
    { columnLabel: 'Form Name', columnName: 'FORMNAME', columnType: 'text' },
    { columnLabel: 'Form Label', columnName: 'FORMLABEL', columnType: 'text' },
    { columnLabel: 'Form Code', columnName: 'FORMCODE', columnType: 'text' },
    { columnLabel: 'Domain Class Type', columnName: 'DOMAINCLASSTYPE', columnType: 'text' },
    { columnLabel: 'Domain Label', columnName: 'DOMAINLABEL', columnType: 'text' },
    { columnLabel: 'Domain Code', columnName: 'DOMAINCODE', columnType: 'text' },
    { columnLabel: 'Form Type', columnName: 'FORMTYPE', columnType: 'text' },
    { columnLabel: 'Form Repeat', columnName: 'FORMREPEAT', columnType: 'text' },
    { columnLabel: 'Special Form', columnName: 'SPECIALFORM', columnType: 'text' },
    { columnLabel: 'Unbliend Form', columnName: 'UNBLIENDFORM', columnType: 'text' },
  ];

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(formMetadataListCount / itemsPerPage);

  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const getStudyLevelForm = async (e) => {
    setLoading(true);
    let data = await studyLevelFormManagementServices.getStudyLevelForm(
      studyId,
      LoginCat,
      StudyMode === "DV" ? "reviewed" : "active",
      searchData,
      pageNumber,
      itemsPerPage
    );
    setFormMetadataList(data?.data || []);
    setFormMetadataListCount(data?.count || 0);
    setLoading(false);
  };

  const handleDragEnd = async (result) => {
    if (!result.destination) return;
    const reordered = [...formMetadataList];
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);
    const indexing = reordered?.map((item, index) => ({
      formId: item.formId,
      index: index,
    }));
    let userData = {
      studyId: studyId,
      type: "studyLevelFormLibrary",
      indexing: indexing,
    }
    let resultIndex = await studyOtherSettingsServices.updateTableIndexing(userData)
    if (resultIndex?.statusCode === 200) {
      setFormMetadataList(reordered);
    }
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedStudyLevelForm = async (pageNumberDeleted, itemsPerPageDeleted) => {
    let data = await studyLevelFormManagementServices.getStudyLevelForm(
      studyId, LoginCat, "deleted", "", pageNumberDeleted, itemsPerPageDeleted
    );
    setFormDeletedMetadata(data?.data || []);
    setFormDeletedMetadataCount(data?.count || 0);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "studyLevelForm",
      studyId,
      metadata?.formId,
      StudyMode,
      pageNumber, itemsPerPage
    );
    setFormActivity(data?.data || []);
    setFormActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  const getStudyLevelFormReviewHistory = async (pageNumber, itemsPerPage) => {
    setReviewActivityLoader(true);
    let data = await studyLevelFormManagementServices.getStudyLevelFormReviewHistory(
      studyId,
      metadata?.formId,
      pageNumber, itemsPerPage
    );
    setFormReviewActivity(data?.data || []);
    setFormReviewActivityCount(data?.count || 0);
    setReviewActivityLoader(false);
  };

  const getTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getTablePropertiesData("studyLevelForm", studyId);
    setTableColumns(data?.data || {});
  };

  const getStudyLevelFormAuditTrials = async (e) => {
    setActivityLoader(true);
    let data = await studyLevelFormManagementServices.getStudyLevelFormAuditTrials(
      studyId, metadata?.formId,
    );
    setFormMetadataHistory(data?.data || []);
    setHistoryLoader(false);
  };

  useEffect(() => {
    getTablePropertiesData()
  }, []);

  useEffect(() => {
    setActiveTab("properties")
  }, [metadata]);

  useEffect(() => {
    getStudyLevelForm();
  }, [searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreStudyLevelForm = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} form metadata!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.type = type;
        let data =
          await studyLevelFormManagementServices.softDeleteRestoreStudyLevelForm(
            userData
          );
        if (data?.statusCode === 200) {
          getStudyLevelForm();
          setFormId("")
          getDeletedStudyLevelForm()
          if (type === "restore") {
            getDeletedStudyLevelForm(pageNumberDeleted, itemsPerPageDeleted);
            setToggle1()
          }
        }
      }
    });
  };

  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update Table Property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setUpdateButtonLoader(true)
        let userData = {};
        userData.type = "studyLevelForm";
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(userData);
        if (data?.statusCode === 200) {
          getStudyLevelForm();
          getTablePropertiesData();
        }
      }
      setUpdateButtonLoader(false)
    });
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          <i
            title={isFormOpen ? "Close Form" : "Add Form Metadata"}
            onClick={() => {
              setIsFormOpen(!isFormOpen);
              setIsDuplicateFormOpen("")
              setFormId("");
            }}
            className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
              }`}
          />
          {formMetadataListCount > 0 && (
            <>
              <div className="vr"></div>
              <i
                title={isDuplicateFormOpen ? "Close Duplicate Form" : "Duplicate Form Metadata"}
                onClick={() => {
                  setIsDuplicateFormOpen(!isDuplicateFormOpen);
                  setIsFormOpen("");
                  setFormId("");
                }}
                className={`fa-solid ${isDuplicateFormOpen ? "fa-table-list" : "fa-clone CP"
                  }`}
              />
              <div className="vr"></div>
              <div className="position-relative">
                <Form.Control
                  type="Search"
                  onChange={(e) => setSearchData(e.target.value)}
                  value={searchData}
                  placeholder="Search..."
                  style={{ width: 200, padding: "3px 10px" }}
                ></Form.Control>
                <CiSearch
                  className="CP position-absolute bg-white"
                  title="Search"
                  style={{ width: 15, top: 4, right: 7 }}
                />
              </div>
            </>
          )}
        </div>
        <div className="hstack gap-2">
          {StudyMode === "DBP Mode" &&
            <button
              onClick={() => { setToggle3() }}
              className={`updateProfile`}
              style={{ fontSize: 12 }}
            >
              Pull Global Form
            </button>
          }
          {formMetadataListCount > 0 && (
            <button
              onClick={() => { setToggle2(); getTablePropertiesData() }}
              className={`updateProfile`}
              style={{ fontSize: 12 }}
            >
              Table Properties
            </button>
          )}
          {(StudyMode === "DBP Mode" && formDeletedMetadataCount > 0) &&
            <button
              onClick={() => {
                setToggle1();
                getDeletedStudyLevelForm(pageNumberDeleted, itemsPerPageDeleted);
              }}
              className={`updateProfile`}
            >
              Deleted History
            </button>
          }
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={formId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={(isFormOpen || isDuplicateFormOpen) ? "20%" : "100%"}
        >
          {isFormOpen ? <AddFormMetadataForm getStudyLevelForm={getStudyLevelForm} /> : isDuplicateFormOpen && <DuplicateFormMetadataForm />}
          {loading ? (
            <div className="hstack justify-content-center h-100">
              <img src={Loader} alt="" style={{ width: 170, height: 170 }} />
            </div>
          ) : formMetadataList?.length === 0 ? (
            <div className="hstack justify-content-center h-100">
              <NoDataFoundTable MSG={"Form metadata list not found!"} />
            </div>
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    {!tableColumns["FORMNAME"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 1)}>Form Name</th>
                    }
                    {!tableColumns["FORMLABEL"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 2)}>Form Label</th>
                    }
                    {!tableColumns["FORMCODE"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 3)}>Form Code</th>
                    }
                    {!tableColumns["DOMAINCLASSTYPE"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 4)}>Domain Class Type</th>
                    }
                    {!tableColumns["DOMAINLABEL"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 4)}>Domain Label</th>
                    }
                    {!tableColumns["DOMAINCODE"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 4)}>Domain Code</th>
                    }
                    {!tableColumns["FORMTYPE"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 5)}>Form Type</th>
                    }
                    {!tableColumns["FORMREPEAT"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 6)}>Form Repeat</th>
                    }
                    {!tableColumns["SPECIALFORM"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 7)}>Special Form</th>
                    }
                    {!tableColumns["UNBLIENDFORM"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 7)}>Unbliend Form</th>
                    }
                    {StudyMode === "DBP Mode" &&
                      <>
                        <th
                          onMouseDown={(e) => onMouseDown(e, 9)}
                          style={{ width: 45 }}
                          className="text-center"
                        >
                          Edit
                        </th>
                        <th
                          onMouseDown={(e) => onMouseDown(e, 10)}
                          style={{ width: 55 }}
                          className="text-center"
                        >
                          Delete
                        </th>
                        <th
                          onMouseDown={(e) => onMouseDown(e, 10)}
                          style={{ width: 65 }}
                          className="text-center"
                        >
                          App Form
                        </th>
                      </>
                    }
                  </tr>
                </thead>
                <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="tableBody" type="ROW">
                    {(provided) => (
                      <tbody ref={provided.innerRef} {...provided.droppableProps}>
                        {formMetadataList?.map((metadata, index) => (
                          <Draggable key={metadata._id} draggableId={metadata._id} index={index}>
                            {(provided, snapshot) => (
                              <tr
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                onClick={() => { setIsFormOpen(false); setIsDuplicateFormOpen(false) }}
                                key={index}
                                className={`CP ${formId === metadata?._id ? "highlighted" : ""} ${snapshot.isDragging ? "selectedRow" : ""}`}
                                title="View Details"
                              >
                                <td
                                  onClick={() => {
                                    setMetadata(metadata);
                                    setFormId(metadata?._id);
                                  }}
                                  className="text-center"
                                >
                                  {index + 1 + startIndex}.
                                </td>
                                {!tableColumns["FORMNAME"] &&
                                  <td className={snapshot.isDragging ? "w-100" : ""} onClick={() => { setMetadata(metadata); setFormId(metadata?._id); }}>
                                    {metadata?.formName}
                                  </td>}
                                {!snapshot.isDragging && !tableColumns["FORMLABEL"] &&
                                  <td onClick={() => { setMetadata(metadata); setFormId(metadata?._id); }}>
                                    {!snapshot.isDragging &&
                                      metadata?.formLabel
                                    }
                                  </td>}
                                {!snapshot.isDragging && !tableColumns["FORMCODE"] &&
                                  <td onClick={() => { setMetadata(metadata); setFormId(metadata?._id); }}>
                                    {metadata?.formCode}
                                  </td>}
                                {!snapshot.isDragging && !tableColumns["DOMAINCLASSTYPE"] &&
                                  <td onClick={() => { setMetadata(metadata); setFormId(metadata?._id); }}>
                                    {metadata?.domainClassType}
                                  </td>}
                                {!snapshot.isDragging && !tableColumns["DOMAINLABEL"] &&
                                  <td onClick={() => { setMetadata(metadata); setFormId(metadata?._id); }}>
                                    {metadata?.domainLabel}
                                  </td>}
                                {!snapshot.isDragging && !tableColumns["DOMAINCODE"] &&
                                  <td onClick={() => { setMetadata(metadata); setFormId(metadata?._id); }}>
                                    {metadata?.domainCode}
                                  </td>}
                                {!snapshot.isDragging && !tableColumns["FORMTYPE"] &&
                                  <td onClick={() => { setMetadata(metadata); setFormId(metadata?._id); }} className="text-capitalize">
                                    {metadata?.formType}
                                  </td>}
                                {!snapshot.isDragging && !tableColumns["FORMREPEAT"] &&
                                  <td onClick={() => { setMetadata(metadata); setFormId(metadata?._id); }} className="text-capitalize">
                                    {metadata?.formRepeat}
                                  </td>}
                                {!snapshot.isDragging && !tableColumns["SPECIALFORM"] &&
                                  <td onClick={() => { setMetadata(metadata); setFormId(metadata?._id); }} className="text-capitalize">
                                    {metadata?.specialForm}
                                  </td>}
                                {!snapshot.isDragging && !tableColumns["UNBLIENDFORM"] &&
                                  <td onClick={() => { setMetadata(metadata); setFormId(metadata?._id); }} className="text-capitalize">
                                    {metadata?.unbliendForm}
                                  </td>}
                                {!snapshot.isDragging && StudyMode === "DBP Mode" &&
                                  <>
                                    <td className="text-center CP" title="Update"
                                      onClick={(e) => {
                                        setMetadata(metadata);
                                        setToggle();
                                        e.stopPropagation();
                                      }}
                                      style={{ pointerEvents: "auto" }}
                                    >
                                      <FaEdit
                                        className="text-muted"
                                      />
                                    </td>
                                    <td className="text-center CP" title="Delete"
                                      onClick={(e) => {
                                        if ((metadata?.qualityCheck === "no") && (metadata?.version === "1")) {
                                          softDeleteRestoreStudyLevelForm(metadata?._id, "delete");
                                          e.stopPropagation();
                                        }
                                      }}
                                      style={{ pointerEvents: "auto", cursor: ((metadata?.qualityCheck === "no") && (metadata?.version === "1")) ? "pointer" : "no-drop" }}
                                    >
                                      <FaTrash
                                        className={((metadata?.qualityCheck === "no") && (metadata?.version === "1")) ? "text-danger" : "text-muted"}
                                      />
                                    </td>
                                    <td className="text-center CP" title="Delete"
                                      onClick={(e) => handleAddNewTab(`${metadata?.formName} (Form Builder)`, "fa-brands fa-wpforms", `formBuilder_${metadata?.formId}`, { formName: metadata?.formName, formId: metadata?.formId, version: metadata?.version })}
                                      style={{ pointerEvents: "auto" }}
                                    >
                                      <FaWpforms
                                        className={((metadata?.qualityCheck === "no") && (metadata?.version === "1")) ? "text-danger" : "text-muted"}
                                      />
                                    </td>
                                  </>
                                }
                              </tr>
                            )}
                          </Draggable>

                        ))}
                        {provided.placeholder}
                      </tbody>
                    )}
                  </Droppable>
                </DragDropContext>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={formMetadataListCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
        {formId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {[
                  "properties",
                  ...(StudyMode === "DBP Mode" && metadata?.qualityCheck === "yes"
                    ? [
                      ...(metadata?.specialForm === "no" ? ["assign Events"] : []),
                      ...(metadata?.specialForm === "yes" ? ["assign Special Event"] : []),
                      ...(metadata?.specialForm === "no" &&
                        !metadata?.initiate &&
                        metadata?.formType === "regular"
                        ? ["initiate"]
                        : []),
                    ]
                    : []),
                  "history",
                  "review History",
                  "activities",
                  "query History",
                ].map((tab) => (
                  <button
                    key={tab}
                    className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                      }`}
                    onClick={() => setActiveTab(tab)}
                    title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>
                )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setFormId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "properties" && (
              <FormMetadataProperties
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                metadata={metadata}
                isFullScreen={isFullScreen}
              />
            )}
            {activeTab === "activities" && (
              <FormMetadataActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                formActivity={formActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                metadata={metadata}
                formActivityCount={formActivityCount}
                isFullScreen={isFullScreen}
              />
            )}
            {activeTab === "review History" && (
              <FormMetadataReviewActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                formReviewActivity={formReviewActivity}
                reviewActivityLoader={reviewActivityLoader}
                getStudyLevelFormReviewHistory={getStudyLevelFormReviewHistory}
                metadata={metadata}
                formReviewActivityCount={formReviewActivityCount}
                isFullScreen={isFullScreen}
              />
            )}
            {activeTab === "history" && (
              <FormMetadataUpdatedHistory
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                formMetadataHistory={formMetadataHistory}
                historyLoader={historyLoader}
                getStudyLevelFormAuditTrials={getStudyLevelFormAuditTrials}
                metadata={metadata}
                isFullScreen={isFullScreen}
              />
            )}
            {activeTab === "assign Events" && (
              <EventListForAssignForm
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                metadata={metadata}
                isFullScreen={isFullScreen}
              />
            )}
            {activeTab === "assign Special Event" && (
              <SpecialEventForAssignForm
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                metadata={metadata}
                isFullScreen={isFullScreen}
              />
            )}
            {activeTab === "initiate" && (
              <EventListForInitiateForm
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                metadata={metadata}
                isFullScreen={isFullScreen}
              />
            )}
            {activeTab === "query History" && (
              <EventQueryHistory
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                metadata={metadata}
                isFullScreen={isFullScreen}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateFormMetadata
        Show={!toggle}
        Hide={setToggle}
        metadata={metadata}
        setFormId={setFormId}
        getStudyLevelForm={getStudyLevelForm}
        Title={"Update Form Metadata"}
      />
      <TableProperties
        Show={!toggle2}
        Hide={setToggle2}
        Title={"Table Properties"}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formColumn={formColumn}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        updateButtonLoader={updateButtonLoader}
        updateTableProperties={updateTableProperties}
      />
      <PullGlobalFormMetadata
        Show={!toggle3}
        Hide={setToggle3}
        Title={"Pull Global Form"}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formCodeList={(formMetadataList || [])?.map(item => item.formCode)}
        getStudyLevelForm={getStudyLevelForm}
      />
      <DeletedFormMetadata
        Show={!toggle1}
        Hide={setToggle1}
        setFormId={setFormId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formDeletedMetadata={formDeletedMetadata}
        getDeletedStudyLevelForm={getDeletedStudyLevelForm}
        formDeletedMetadataCount={formDeletedMetadataCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreStudyLevelForm={softDeleteRestoreStudyLevelForm}
        Title={"Deleted Form Metadata History"}
      />
    </>
  );
};

export default FormMetadataDataList;
